import { apiSlice } from '../api/apiSlice';
import {
  NotificationProps,
  NotificationQueryParamsProps,
  UnreadNotificationsCountProps
} from './notifications.types';

export const notificationsApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => {
    return {
      clearAllNotifications: build.mutation<void, void>({
        invalidatesTags: ['Notification'],
        query: () => ({
          body: { clearAll: true },
          method: 'PATCH',
          url: '/notifications/clear'
        })
      }),
      clearNotification: build.mutation<string, string>({
        invalidatesTags: ['Notification'],
        query: (id: string) => ({
          body: { notificationIds: [id] },
          method: 'PATCH',
          url: '/notifications/clear'
        }),
        transformResponse: (_response, _meta, arg) => arg
      }),
      getNotifications: build.query<
        { data: NotificationProps[]; info: { totalCount: number } },
        { params: NotificationQueryParamsProps }
      >({
        keepUnusedDataFor: 0,
        providesTags: (result) =>
          result
            ? [
                'Notification',
                ...result.data.map(({ _id }) => ({ id: _id, type: 'Notification' as const }))
              ]
            : ['Notification'],
        query: ({ params }) => {
          let queryParams = params;
          if (params?.startCreateDate && !params?.endCreateDate) {
            queryParams = {
              ...params,
              createdAt: params.startCreateDate
            };
            delete queryParams.startCreateDate;
          }
          return {
            params: queryParams,
            url: `/notifications`
          };
        },
        transformResponse: (response: {
          data: NotificationProps[];
          info: { totalCount: number };
        }) => response
      }),
      getNotificationsUnreadCount: build.query<UnreadNotificationsCountProps, void>({
        query: () => '/notifications/unread-count',
        transformResponse: (response: { data: UnreadNotificationsCountProps }) => response.data
      }),
      markSeenNotifications: build.mutation<void, void>({
        invalidatesTags: ['Notification'],
        query: () => ({
          method: 'PATCH',
          url: '/notifications/mark-seen'
        })
      })
    };
  }
});

export const {
  useClearAllNotificationsMutation,
  useClearNotificationMutation,
  useLazyGetNotificationsQuery,
  useLazyGetNotificationsUnreadCountQuery,
  useMarkSeenNotificationsMutation
} = notificationsApiSlice;
